import { cn } from "@/utils";
import { ChevronRight, ChevronsUpDown, type LucideIcon } from "lucide-react";

/**
 * IconTile — the container-head lead from the ratified left-rail spec: a
 * size-5 rounded-sm coin on the quiet chip fill (bg-n-10 / text-n-70 —
 * ground-true in both modes; the full-inversion coin was rejected), glyph
 * size-3 centered. Three states:
 *
 *   rest      → the section's glyph
 *   disclose  → ChevronRight on any hover inside the head row (`group`),
 *               rotating 90° when the head carries data-state="open"
 *   reorder   → ChevronsUpDown while the section is being dragged
 *
 * The chevron family is semantic: one chevron discloses, the up-down pair
 * reorders.
 */
export function IconTile({
  icon: Icon,
  reordering = false,
  className,
}: {
  icon: LucideIcon | React.ComponentType<{ className?: string }>;
  reordering?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "relative flex size-5 shrink-0 items-center justify-center rounded-sm bg-n-10 text-n-70",
        className,
      )}
    >
      {reordering ? (
        <ChevronsUpDown className="size-3" />
      ) : (
        <>
          <Icon className="absolute size-3 transition-opacity duration-150 group-hover:opacity-0" />
          <ChevronRight className="absolute size-3 opacity-0 transition-[opacity,transform] duration-150 ease-out group-hover:opacity-100 group-data-[state=open]:rotate-90" />
        </>
      )}
    </span>
  );
}
